// import React, { Suspense } from "react";
// import { createRoot } from 'react-dom/client';
// import { HashRouter } from "react-router-dom";
// import App from "./App";
// import Loader from "./layouts/loader/Loader";
// import './assets/scss/style.scss';
// import reportWebVitals from "./reportWebVitals";

// const root = createRoot(document.getElementById('root'));

// root.render(
//   <Suspense fallback={<Loader/>}>
//     <HashRouter>
//       <App />
//     </HashRouter>
//   </Suspense>
// );

// <<<<<<< HEAD
// // // If you want to start measuring performance in your app, pass a function
// // // to log results (for example: reportWebVitals(console.log))
// // <<<<<<< HEAD
// // // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals   pupp update code
// // =======
// // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals   pupp update file
// // >>>>>>> origin/dev_ready
// =======
// >>>>>>> origin/dev_ready
// reportWebVitals();

import React, { Suspense } from "react";
import { createRoot } from 'react-dom/client';
import { HashRouter } from "react-router-dom";
import App from "./App";
import Loader from "./layouts/loader/Loader";
import './assets/scss/style.scss';
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById('root'));

root.render(
  <Suspense fallback={<Loader/>}>
    <HashRouter>
      <App />
    </HashRouter>
  </Suspense>
);

reportWebVitals();